import Validation from '../lib/validation'

export default function validate(data) {
  const validator = new Validation(data)
  validator.isRequired('email', 'Email je povinný')
  validator.isRequired('password', 'Heslo je povinné')
  validator.isEmail('email', 'Email není ve správném formátu')
  return validator.validate()
}



// WEBPACK FOOTER //
// ./src/common/auth/validations.js